// DEPENDENCIES
import clsx from 'clsx';

// STYLES
import styles from './numberCell.module.scss';

export default function NumberCell({ children, value = children, className }) {
  return ![undefined, null, ''].includes(value) ? (
    <div className={clsx(styles.number, className)}>{value.toLocaleString('en-US')}</div>
  ) : null;
}
